import {makeAutoObservable} from "mobx";
import {FEE_STORE_LEVEL, POLICY_FEES_DEFAULS_BY_FEE_STORE_LEVEL} from "../../policies/constants";
import RmaFeeStore, {IRMAFeeDto} from "./rma-fee-store";


class RmaFeesListStore {
	private _returnFee = new RmaFeeStore(POLICY_FEES_DEFAULS_BY_FEE_STORE_LEVEL[FEE_STORE_LEVEL.RETURN] as IRMAFeeDto);
	private _labelFee = new RmaFeeStore(POLICY_FEES_DEFAULS_BY_FEE_STORE_LEVEL[FEE_STORE_LEVEL.SHIPPING_LABEL] as IRMAFeeDto);
	
	constructor() {
		makeAutoObservable(this);
	}
	
	get returnFee() { return this._returnFee; }
	get labelFee() { return this._labelFee; }
}

export default RmaFeesListStore;